"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = createRender;

var _react = _interopRequireDefault(require("react"));

var _reactStaticContainer = _interopRequireDefault(require("react-static-container"));

var _ElementsRenderer = _interopRequireDefault(require("./ElementsRenderer"));

// These are intentionally not renderLoading, renderFetched, and renderFailure
// from Relay, because these don't quite correspond to those conditions.
function createRender(_ref) {
  var renderPending = _ref.renderPending,
      renderReady = _ref.renderReady,
      renderError = _ref.renderError;
  return function render(renderArgs) {
    var error = renderArgs.error,
        elements = renderArgs.elements;
    var element;

    if (error) {
      element = renderError ? renderError(renderArgs) : null;
    } else if (!elements) {
      element = renderPending ? renderPending(renderArgs) : undefined;
    } else if (renderReady) {
      element = renderReady(renderArgs);
    } else {
      element = _react["default"].createElement(_ElementsRenderer["default"], {
        elements: elements
      });
    }

    var hasElement = element !== undefined;
    return _react["default"].createElement(_reactStaticContainer["default"], {
      shouldUpdate: hasElement
    }, hasElement ? element : null);
  };
}

module.exports = exports.default;